export default __webpack_public_path__ + "static/media/pptx.5774217d.svg";